var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArchiveOutlined = function SvgArchiveOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128 426.667H85.333V170.795c0-23.638 19.414-42.795 42.326-42.795H896.34a42.24 42.24 0 0 1 42.326 42.795v255.872H896v426.709A42.496 42.496 0 0 1 853.632 896H170.368A42.496 42.496 0 0 1 128 853.376zm682.667 0H213.333v384h597.334zm-640-213.334v128h682.666v-128zM384 512h256v85.333H384z"
  })));
};
export default SvgArchiveOutlined;